import { StyledFormSchema, useFormHook } from "@smartdevis/forms/src"
import { CrbLicenseDetails } from "@smartdevis/server/src/crbNpkCatalogs"
import { Button } from "@smartdevis/ui/src/Button"
import { Modal } from "@smartdevis/ui/src/Modal"
import { Spinner } from "@smartdevis/ui/src/Spinner"
import { FlexRow, HorizontalSpace } from "@smartdevis/ui/src/utils/common"
import { F0, F1 } from "@smartdevis/utils/src/types"
import { validString } from "@smartdevis/utils/src/validators"
import React, { useState } from "react"
import { SubmitButton } from "../../../components"
import { StyledForm } from "../../../components/forms"
import { mkFormSchema, mkHiddenSchema, mkTextSchema } from "../../../components/forms/formSchemas"
import { i18n } from "../../../services/translations"
import styled from "styled-components"
import { themeColor } from "@smartdevis/ui/src/utils/theme"
import { asyncConnect } from "../../../resolvers"
import { NPKCatalogs } from "@smartdevis/server/src/domain"
import { InfoBox } from "@smartdevis/ui/src/InfoBox"
import { getLicenceUnlockInfo, loginWithLicenceUnlockInfo } from "../crb-npk-catalogs/helper"
import { Authentication } from "../../../store/authState"
import { ActiveWorkStations } from "../crb-npk-catalogs/helper/crb-catalog-active-workstations"

export type NpkCatalogsLoginProps = {
    visible: boolean
    auth: Authentication
    credentials: NPKCatalogs.Credentails
    CRBAuthStatus: NPKCatalogs.AccessStatus
    onClose: F0
    setCredentials: F1<NPKCatalogs.Credentails>
    setCRBAuthStatus: F1<NPKCatalogs.AccessStatus>
}
export const NpkCatalogsLogin = asyncConnect({ stateResolvers: ["user"], actions: ["logon"] })<NpkCatalogsLoginProps>(p => {

    const { auth } = p;

    const [licenseUnlockInfo, setLicenseUnlockInfo] = useState<number|null>(null);
    const [loading, setLoading] = useState(false);

    const getStyledLicenseUnlockLoginSchema: F0<StyledFormSchema<Pick<CrbLicenseDetails, "customerID" | "licenseID" | "workStationID">>> = () => [
        { type: "Title", value: i18n("Login to CRB Server") },
        { type: "Row", value: ["customerID"] },
        { type: "Row", value: ["licenseID"] },
        { type: "Row", value: ["workStationID"] }
    ]

    const CrbLicenseDetailsValidation = {
        customerID: validString,
        licenseID: validString,
        workStationID: validString
    }

    const getSchema = () =>
        mkFormSchema<Pick<CrbLicenseDetails, "customerID" | "licenseID" | "workStationID">>(CrbLicenseDetailsValidation, {
            customerID: mkTextSchema("Customer ID"),
            licenseID: mkTextSchema("License ID"),
            workStationID: mkHiddenSchema("Workstation ID"),
        })
    

    const onSubmit = () => {
        if (result.type === "Ok" && auth.type === "Authenticated") {
            const credentials = { ...result.value }
            p.setCredentials({ ...result.value, language: p.credentials.language })
            setLoading(true);
            getLicenceUnlockInfo(auth, credentials).then((res) => {
                const licenseUnlockInfo: NPKCatalogs.LicenseUnlockInfo = res.value as NPKCatalogs.LicenseUnlockInfo;
                setLicenseUnlockInfo(licenseUnlockInfo.getLicenceUnlockInfoResult);
                switch (licenseUnlockInfo.getLicenceUnlockInfoResult) {
                    // Action Successful
                    case 0:
                        //logging in to the partner module
                        loginWithLicenceUnlockInfo(auth, { licenceUnlockInfo: licenseUnlockInfo.lui, signature: licenseUnlockInfo.signature }).then((res) => {
                            const loginStatus: NPKCatalogs.AccessStatus = res.value as NPKCatalogs.AccessStatus;
                            p.setCRBAuthStatus(loginStatus);
                            switch (loginStatus.status) {
                                //status 0 = Action completed successfully
                                case 0:
                                    // getLicenceIDs(auth, { customerID: credentials.customerID, licenseID: credentials.licenseID }).then((res) => {
                                    //     const licenseIds = res.value;
                                    //     console.warn('licenseIds', licenseIds);
                                    // });
                                    // getLicenceInfo(auth, credentials).then((res) => {
                                    //     const licenseInfo = res.value;
                                    //     console.warn('licenseInfo', licenseInfo);
                                    // })
                                    break;
                                //status -1 = Invalid signature. Action not completed
                                case -1: break;
                                //status -2 = Licence for the requested service not found.
                                case -2: break;
                            }
                        }).catch()


                        break;
                    // Action Successful + No. of Permissions exceeded
                    case 1:
                        // getSubscribedWorkStations(auth, { customerID: credentials.customerID, licenseID: credentials.licenseID }).then((res) => {
                        //     const _activeWorkstations: NPKCatalogs.Workstation[] = res.value as NPKCatalogs.Workstation[];
                        //     setActiveWorkStations(_activeWorkstations);
                        //     // console.warn('activeWorkstations',activeWorkstations);

                        // }).catch()

                        break;
                    // invalid info
                    case 100: break;
                }
            }).catch((err) => {
                console.warn(err)
            }).finally(()=>{
                setLoading(false);
            })
        }
    }

    const { formViewProps, handleSubmit, result } = useFormHook({
        schema: getSchema(),
        onSubmit,
        initialValue: { customerID: '1060169', licenseID: 'C4B68E4A1', workStationID: p.user.userId }
    })

    return (
        <Modal
            header={"CRB Catalogs login"}
            size="xl"
            height="80vh"
            visible={p.visible}
            onClose={p.onClose}
        >
            {loading && <Spinner/>}
            {licenseUnlockInfo && licenseUnlockInfo !== 0 &&
                <FlexRow justifyCenter>
                    <InfoBox type="warning">
                        {licenseUnlockInfo === 1 ? 'Action Successful but No. of Permissions exceeded' : 'Invalid credentials'}
                    </InfoBox>
                </FlexRow>
            }
            <FlexRow justifyCenter>
                <Form onSubmit={handleSubmit}>
                    <AdditionalForm>
                        <StyledForm {...formViewProps} styledSchema={getStyledLicenseUnlockLoginSchema()} />
                    </AdditionalForm>
                    <FlexRow alignCenter justifyEnd>
                        <Button type="button" btnType="action" onClick={p.onClose} data-cy="projects-cancel">
                            {i18n("Cancel")}
                        </Button>

                        <HorizontalSpace base="16px" />
                        <SubmitButton
                            data-cy="projects-submit"
                            // loading={actionState.type === "Processing"}
                            // disabled={actionState.type === "Processing"}
                            type="submit">
                            {i18n('Submit')}
                        </SubmitButton>
                    </FlexRow>
                </Form>
            </FlexRow>
            {licenseUnlockInfo === 1 && <ActiveWorkStations auth={auth} credentials={p.credentials} />}
        </Modal>
    )
})



const Form = styled.form`
    max-width: 800px;
`
const AdditionalForm = styled.div<{ active?: boolean }>`
    padding: 16px;
    background-color: ${p => (p.active ? themeColor("grey35") : "white")};
    margin-bottom: 16px;
`
